import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a482eb42"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nav-margin"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_ListViewCpt = _resolveComponent("ListViewCpt");
  const _component_PageNavBackLayoutCpt = _resolveComponent("PageNavBackLayoutCpt");
  return _openBlock(), _createBlock(_component_PageNavBackLayoutCpt, {
    class: "page"
  }, {
    default: _withCtx(() => [_createVNode(_component_ListViewCpt, {
      ref: "ListViewCpt",
      request: $data.listRequest
    }, {
      default: _withCtx(({
        item
      }) => [_hoisted_1, _createVNode(_component_van_cell, {
        title: item.productName
      }, null, 8, ["title"]), _createVNode(_component_van_cell, {
        title: item.chnName
      }, {
        label: _withCtx(() => [_createTextVNode(_toDisplayString(item.queueNo ? '编号：' + item.queueNo : ''), 1)]),
        default: _withCtx(() => [_createElementVNode("span", {
          style: _normalizeStyle({
            color: $options.getStatusStyle(item.queueStatus)
          })
        }, _toDisplayString(_ctx.formatSelectColumn($data.codeResItems, 'queueStatus', {
          queueStatus: item.queueStatus
        })), 5)]),
        _: 2
      }, 1032, ["title"])]),
      _: 1
    }, 8, ["request"])]),
    _: 1
  });
}